export function validateHasSpecialCharacter(value: string) {
  return value && /[!#$%&()*+,/<=>?@^_\-]/.test(value);
}
